import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet, apiPost } from '@/shared/utils/requestBuilder';

import type {
  GetHistoryParams,
  InternalChatHistoryResult,
  InternalChatMensagem,
  SendMessageInput,
} from '../../types';

const unwrap = <T>(body: unknown): T => {
  if (typeof body === 'object' && body !== null && 'data' in body) {
    return (body as { data: T }).data;
  }
  return body as T;
};

export const messagesService = {
  history: async (params: GetHistoryParams): Promise<InternalChatHistoryResult> => {
    const queryParams: Record<string, string | number | boolean> = {
      conversaId: params.conversaId,
    };
    if (params.cursor) queryParams.cursor = params.cursor;
    if (params.limit !== undefined) queryParams.limit = params.limit;
    if (params.direcao) queryParams.direcao = params.direcao;

    const response = await apiGet('/mensagens/history', queryParams);
    if (!response.ok) await throwApiError(response, 'Erro ao carregar histórico');
    const body = (await response.json()) as unknown;
    return unwrap<InternalChatHistoryResult>(body);
  },

  send: async (input: SendMessageInput): Promise<InternalChatMensagem> => {
    const response = await apiPost('/mensagens/chat-interno', input);
    if (!response.ok) await throwApiError(response, 'Erro ao enviar mensagem');
    const body = (await response.json()) as unknown;
    return unwrap<InternalChatMensagem>(body);
  },

  sendWithAnexo: async (input: SendMessageInput): Promise<InternalChatMensagem> => {
    const form = new FormData();
    form.append('conversaId', input.conversaId);
    if (input.conteudo) form.append('conteudo', input.conteudo);
    if (input.idMensagemReferenciaId) {
      form.append('idMensagemReferenciaId', input.idMensagemReferenciaId);
    }
    if (input.file) form.append('file', input.file);

    const response = await apiPost('/mensagens/chat-interno/anexo', form);
    if (!response.ok) await throwApiError(response, 'Erro ao enviar anexo');
    const body = (await response.json()) as unknown;
    return unwrap<InternalChatMensagem>(body);
  },

  resendTemplate: async (mensagemId: string): Promise<InternalChatMensagem> => {
    const response = await apiPost(`/mensagens/${mensagemId}/resend-template`);
    if (!response.ok) await throwApiError(response, 'Erro ao reenviar template');
    const body = (await response.json()) as unknown;
    return unwrap<InternalChatMensagem>(body);
  },
};
